import React from "react";
import LoginForm from "./LoginForm";
import Posts from "./Posts";
import { isAuthenticated } from "../utils/auth";

const HomePage = ({ setLoggedIn, doRefreshPosts, appRefresh }) => {
  // if the user is not logged in, show the login form.  Otherwise, show the post form
  return (
    <div>
      {!isAuthenticated() ? (
        <>
          <LoginForm setLoggedIn={setLoggedIn} />
        </>
      ) : (
        <Posts doRefreshPosts={doRefreshPosts} appRefresh={appRefresh} />
      )}
    </div>
  );
};

export default HomePage;
